import { Columns, KeyValue, Section, Skeleton, Text } from '@ui';
import { useTranslation } from 'react-i18next';
import { InstallSection } from '../pwa/InstallSection';
import { errorMessage } from '../../lib/errors';
import { ReleaseNotesList } from './ReleaseNotesList';
import { releaseNotes } from './releaseNotes';
import { useMeta } from './useMeta';

/** Version, license and the source code of the running version (AGPL § 13, OSS-006). */
export function AboutPage() {
  const { t } = useTranslation();
  const meta = useMeta();
  return (
    <Columns>
      <Section variant="content" title={t('about.title')}>
        {meta.isPending && <Skeleton lines={3} />}
        {meta.error && (
          <Text tone="danger" role="alert">
            {errorMessage(meta.error)}
          </Text>
        )}
        {meta.data && (
          <KeyValue
            items={[
              { key: 'version', label: t('about.versionLabel'), value: meta.data.version },
              { key: 'commit', label: t('about.commit'), value: meta.data.commit?.slice(0, 7) },
              { key: 'license', label: t('about.license'), value: meta.data.license },
              {
                key: 'source',
                label: t('about.source'),
                value: (
                  <a href={meta.data.source_url} target="_blank" rel="noreferrer">
                    {t('about.sourceCode')}
                  </a>
                ),
              },
            ]}
          />
        )}
      </Section>
      <InstallSection />
      <Section variant="content" title={t('releaseNotes.heading')}>
        <ReleaseNotesList notes={releaseNotes} />
      </Section>
    </Columns>
  );
}
